const schools = {
  schools: "Schulen",
  school: "Schule",
  schoolName: "Schulname",
  schoolAddress: "Schuladresse",
  schoolDetail: "Schul-Details",
  schoolStatus: "Status",
  schoolStatusProspect: "Interessent",
  schoolStatusContract: "Unter Vertrag",
  schoolIsPrepaidStudentSubscriptions: "Abonnement für Lernende",
  schoolContact: "Kontakt",
  purgeSelection: "Ausgewählte Schulen löschen",
  purgeWarning:
    "Alle Klassen, Aufgaben und zugehörigen Daten werden dauerhaft gelöscht.",
  clickToDeleteSchool:
    "Markieren Sie dieses Kästchen, um die Schule ebenfalls aus der Datenbank zu löschen.",
  clickToDeleteSchools:
    "Markieren Sie dieses Kästchen, um die Schulen ebenfalls aus der Datenbank zu löschen.",
  numberSelected: "Anzahl der ausgewählten Schulen:",
  purgeSingleSchool: "Diese Schule löschen?",
  purgeSchool: "Diese Schule löschen",
  establishment: "Schule",
  establishments: "Schulen",
  establishmentsAndClasses: "Schulen und Klassen",
};

export default schools;
